// Centralized payment method constants to avoid magic strings across the app
// Keep this in sync with backend enum values

export const PaymentMethod = Object.freeze({
  CASH: 'CASH',
  // CARD: 'CARD',
  STRIPE_LINK: 'STRIPE_LINK',
  STRIPE_TERMINAL: 'STRIPE_TERMINAL',
  BOG_TERMINAL: 'BOG_TERMINAL',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CHECK: 'CHECK',
});

export const PaymentMethodLabels = Object.freeze({
  [PaymentMethod.CASH]: 'Cash',
  // [PaymentMethod.CARD]: 'Credit/Debit Card',
  [PaymentMethod.STRIPE_LINK]: 'Stripe SMS',
  [PaymentMethod.STRIPE_TERMINAL]: 'Stripe POS Terminal',
  [PaymentMethod.BOG_TERMINAL]: 'BOG POS Terminal',
  [PaymentMethod.BANK_TRANSFER]: 'Bank Transfer',
  [PaymentMethod.CHECK]: 'Check',
});


